module.exports = __webpack_public_path__ + "img/smart3.e3070cea.svg";